import { Typography } from "@mui/material";
import React from "react";

export function TextView({ children, ...props }) {
  return (
    <Typography
      {...props}
      color={props?.isUrl ? "#8576FF" : "#4c5a6a"}
      sx={{
        cursor: props?.isUrl ? "pointer" : null,
        display: "block",
        marginBottom: "8px",
        overflow: "hidden",
        textOverflow: "ellipsis",
        height: props?.isUrl ? "24%" : "auto",
      }}
      component={props?.isUrl ? "a" : "p"}
      href={props?.isUrl ? props?.href : undefined}
      target={props?.isUrl ? "_blank" : undefined}
      rel={props?.isUrl ? "noopener noreferrer" : undefined}>
      {children}
    </Typography>
  );
}
